<template>
  <div class="companySetting">
    <el-card>
      <el-form
        ref="companyForm"
        :model="companyForm"
        :label-width="formLabelWidth"
        :rules="companyFormRules"
      >
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="网站ico" prop="icoPic">
            <el-upload
              :headers="upLoadData"
              class="icoPic-uploader"
              :action="fileAction"
              :show-file-list="false"
              list-type="picture"
              :on-success="handleIcoPicSuccess"
              :before-upload="beforeIcoPicUpload"
            >
              <img v-if="companyForm.icoPic" :src="companyForm.icoPic" class="icoPic" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <div class="content-texts">
              <span class="content-texts">建议：上传尺寸为16*16的ico图片</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="网站标题" prop="title">
              <el-input
                v-model="companyForm.title"
                placeholder="请输入网站标题"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="网站logo" prop="logoPic">
            <el-upload
              :headers="upLoadData"
              class="logoPic-uploader"
              :action="fileAction"
              :show-file-list="false"
              list-type="picture"
              :on-success="handleLogoPicSuccess"
              :before-upload="beforeLogoPicUpload"
            >
              <img v-if="companyForm.logoPic" :src="companyForm.logoPic" class="logoPic" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <div class="content-texts">
              <span class="content-texts">建议：上传尺寸为200*36的PNG图片</span>
            </div>
          </el-form-item>
        </el-col>
        </el-row> -->
        <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="登录展示图" prop="loginPic">
            <el-upload
              :headers="upLoadData"
              class="loginPic-uploader"
              :action="fileAction"
              :show-file-list="false"
              list-type="picture"
              :on-success="handleLoginPicSuccess"
              :before-upload="beforeLoginPicUpload"
            >
              <img v-if="companyForm.loginPic" :src="companyForm.loginPic" class="loginPic" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <div class="content-texts">
              <span class="content-texts">建议：上传尺寸为1920*600的PNG、JPG图片，大小不超过1M</span>
            </div>
          </el-form-item>
        </el-col>
        </el-row>
        <!-- <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="注册展示图" prop="registerPic">
            <el-upload
              :headers="upLoadData"
              class="registerPic-uploader"
              :action="fileAction"
              :show-file-list="false"
              list-type="picture"
              :on-success="handleRegisterPicSuccess"
              :before-upload="beforeRegisterPicUpload"
            >
              <img
                v-if="companyForm.registerPic"
                :src="companyForm.registerPic"
                class="registerPic"
              />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <div class="content-texts">
              <span class="content-texts">建议：上传尺寸为1920*600的PNG、JPG图片，大小不超过1M</span>
            </div>
          </el-form-item>
        </el-col>
        </el-row> -->

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="咨询电话" prop="mobile">
              <el-input
                v-model="companyForm.mobile"
                placeholder="请输入咨询电话"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="咨询QQ" prop="qq">
              <el-input
                v-model="companyForm.qq"
                placeholder="请输入咨询QQ"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="备案号" prop="recodeNo">
              <el-input
                v-model="companyForm.recodeNo"
                placeholder="请输入备案号"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="营业执照" prop="businessLicensePic">
            <el-upload
              :headers="upLoadData"
              class="businessLicensePic-uploader"
              :action="fileAction"
              :show-file-list="false"
              list-type="picture"
              :on-success="handleBusinessLicensePicSuccess"
              :before-upload="beforeBusinessLicensePicUpload"
            >
              <img
                v-if="companyForm.businessLicensePic"
                :src="companyForm.businessLicensePic"
                class="businessLicensePic"
              />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
            <div class="content-texts">
              <span class="content-texts">建议：上传带有水印的营业执照，支持PNG、JPG格式，大小不超过1M</span>
            </div>
          </el-form-item>
        </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="公司名称" prop="showName">
              <el-input
                v-model="companyForm.showName"
                placeholder="请输入首页展示公司名称"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="公司地址">
              <div class="addAddress-detail">
                <div v-for="(item,index) in companyForm.addressList" :key="index">
                  <div class="addAddress-form">
                    <el-form-item>
                      <el-input
                        v-model="companyForm.addressList[index]"
                        placeholder="请输入首页展示公司名称"
                        auto-complete="off"
                        maxlength="32"
                      ></el-input>
                      <i v-if="index!=0"
                        style="float:right;font-size:16px;margin-right:20px;margin-top:12px;cursor:pointer;"
                        class="el-icon-delete"
                        @click="deleteAddress(index)"
                      ></i>
                    </el-form-item>
                  </div>
                </div>

                <!-- <div class="addAddress-form"> -->
                  <el-button type="text" @click="addAddress()">
                    添加公司地址
                  </el-button>
                <!-- </div> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="text-align:center;">
        <el-button type="primary" @click="addCompanySetting">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      companyForm: {
        icoPic: "",
        logoPic: "",
        loginPic: "",
        registerPic: "",
        mobile: "",
        qq: "",
        recodeNo: "",
        businessLicensePic: "",
        showName: "",
        firstAddress: "",
        addressList: ['']
      },
      formLabelWidth: "80px",
      companyFormRules: {
        mobile: [
          // {
          //   required: true,
          //   message: "请输入手机号",
          //   trigger: "blur"
          // },
          {
            pattern: /^1(3|4|5|6|7|8)\d{9}$/,
            message: "手机号格式不正确"
          }
        ],
        // name: [
        //   {
        //     required: true,
        //     message: "请输入商品名称",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 20,
        //     message: "商品名称长度在1到100个字"
        //   }
        // ],
        // type: {
        //   required: true,
        //   message: "请选择商品类型",
        //   trigger: "change"
        // },
        // free: {
        //   required: true,
        //   message: "请选择付费",
        //   trigger: "change"
        // },
        // onTime: {
        //   required: true,
        //   message: "请选择上架时间",
        //   trigger: "change"
        // },
        // img: {
        //   required: true,
        //   message: "请选择商品图片",
        //   trigger: "change"
        // },
        // tags: [
        //   {
        //     required: true,
        //     message: "请输入标签",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 1000,
        //     message: "标签长度在1到1000个字"
        //   }
        // ],
        // detail: [
        //   {
        //     required: true,
        //     message: "请输入详细介绍",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 65535,
        //     message: "详细介绍长度在1到65535个字"
        //   }
        // ]
      }
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
    upLoadData() {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent"
      };
    }
  },
  methods: {
    beforeIcoPicUpload(file) {
      // const isJPG = file.type === "image";
      const isLt2M = file.size / 1024 / 1024 < 1;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleIcoPicSuccess(res, file) {
      this.companyForm.icoPic = file.response.data;
      // console.log(this.companyForm)
    },

    beforeLogoPicUpload(file) {
      // const isJPG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 PNG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleLogoPicSuccess(res, file) {
      this.companyForm.logoPic = file.response.data;
    },

    beforeLoginPicUpload(file) {
      // const isJPG = file.type === "image/png" || file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 1;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleLoginPicSuccess(res, file) {
      this.companyForm.loginPic = file.response.data;
    },

    beforeRegisterPicUpload(file) {
      // const isJPG = file.type === "image/png" || file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 1;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleRegisterPicSuccess(res, file) {
      this.companyForm.registerPic = file.response.data;
    },

    beforeBusinessLicensePicUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleBusinessLicensePicSuccess(res, file) {
      this.companyForm.businessLicensePic = file.response.data;
    },

    addAddress() {
      if(!this.companyForm.addressList){
        this.companyForm.addressList=[];
      }
      if (this.companyForm.addressList.length > 2) {
        // this.$confirm("公司地址最多只能添加三个", "提示", {
        //   confirmButtonText: "确定",
        //   type: "warning"
        // });
        this.$message.error("公司地址最多添加三个");
      } else {
        this.companyForm.addressList.push('');
      }
    },
    deleteAddress(index) {
      console.log(index);
      this.$confirm("是否删除此地址?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // this.addForm.obj.splice(index, 1);
        this.companyForm.addressList.splice(index, 1);
      });
    },
    addCompanySetting() {
      this.$refs.companyForm.validate(valid => {
        if (valid) {
          this.api.schoolPage.addAgentCompanyInfo(this.companyForm).then(result => {
            if (result.success) {
              this.getAgentCompanyInfo();
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    getAgentCompanyInfo(){
      this.api.schoolPage.getAgentCompanyInfo({}).then(result => {
            if (result.success) {
              if(result.data){
                this.companyForm=result.data;
              }
            } else {
              this.$message.error(result.message);
            }
          });
    }
  },
  watch: {},
  mounted() {
    this.getAgentCompanyInfo();
  }
};
</script>
<style lang="less">
.companySetting{

.el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-upload:hover {
  border-color: #409eff;
}

.icoPic {
  width: 80px;
  height: 80px;
  display: block;
}

.logoPic {
  width: 200px;
  height: 36px;
  display: block;
}

.loginPic {
  width: 640px;
  height: 200px;
  display: block;
}

.registerPic {
  width: 640px;
  height: 200px;
  display: block;
}

.businessLicensePic {
  width: 300px;
  height: 420px;
  display: block;
}
.companySetting{
.el-icon-plus {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
}


.addAddress-detail {
  border: 1px solid rgba(238, 238, 238, 1);
  padding: 10px;
}

.addAddress-form {
  // background-color: rgba(246, 249, 250, 1);
  // border: 1px #d9d9d9;
  height: 38px;
  // padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  // margin-top: 10px;
}

.content-texts {
  border-width: 0px;
  position: absolute;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #a2aabc;
  line-height: 12px;
  margin-top: 3px;
}

.addAddress-form .el-input {
  width: 90%;
}
}
</style>



// WEBPACK FOOTER //
// src/components/schoolPage/companySetting.vue